import { CountingSchemes } from '@ahaslides-product/frontend-toolkit'
import Sentry from '@/3rd-parties/sentry'

const SEED_RETRIES = 1

const report = (error) => Sentry.captureException(error)

const countingGroups = (slide) => [
  CountingSchemes.answerCountPerAnswerValue({
    slideId: slide.id,
    slideVersion: slide.version,
  }),
]

const countingKeys = (slide) => [
  CountingSchemes.answererCountPerQuestion({
    slideId: slide.id,
    slideVersion: slide.version,
    questionId: 0,
  }),
]

const countingActions = {
  subscribeCountingForSlideAction: ({ dispatch, getters }, { slide }) => {
    if (!getters.canUsePollLiveProxy || !slide?.id) return
    try {
      dispatch('counting/subscribe', {
        keys: countingKeys(slide),
        groups: countingGroups(slide),
        retries: SEED_RETRIES,
        onError: report,
      }, { root: true }).catch(report)
    } catch (error) {
      report(error)
    }
  },

  unsubscribeCountingForSlideAction: ({ dispatch }, { slide }) => {
    if (!slide?.id) return
    try {
      dispatch('counting/unsubscribe', {
        keys: countingKeys(slide),
        groups: countingGroups(slide),
      }, { root: true })
    } catch (error) {
      report(error)
    }
  },
}

export default countingActions
